import type { Business } from '../types/business'

export function buildVCard(b: Business): string {
  return [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `N:${b.profissional};;;;`,
    `FN:${b.profissional} — ${b.especialidade}`,
    `ORG:${b.nome}`,
    `TITLE:${b.especialidade}`,
    `TEL;TYPE=CELL:${b.telefoneE164}`,
    `EMAIL;TYPE=INTERNET:${b.email}`,
    `ADR;TYPE=WORK:;;${b.endereco};${b.complemento};;;Brasil`,
    `URL:https://${b.site}`,
    'END:VCARD',
  ].join('\n')
}

export function downloadVCard(b: Business): void {
  const blob = new Blob([buildVCard(b)], { type: 'text/vcard;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `${b.profissional.replace(/\s+/g, '-').toLowerCase()}.vcf`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text)
      return true
    }
    const area = document.createElement('textarea')
    area.value = text
    area.style.position = 'fixed'
    area.style.opacity = '0'
    document.body.appendChild(area)
    area.select()
    const ok = document.execCommand('copy')
    document.body.removeChild(area)
    return ok
  } catch {
    return false
  }
}

export function pageUrl(): string {
  if (typeof window === 'undefined') return ''
  return window.location.href
}
